var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useGlobalContext } from '@honeycomb/data';
import { Button, Paper, Skeleton } from '@honeycomb/ui-core';
import React from 'react';
import { MapButtonImage } from './MapButtonImage';
export function HotelMapButton(_a) {
    var { onClick, loading } = _a, other = __rest(_a, ["onClick", "loading"]);
    const { resourceStrings: { SRP_MAPBUTTON_LABEL }, } = useGlobalContext();
    return (React.createElement(Paper, Object.assign({ button: !loading, radius: "s", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", onClick: !loading ? onClick : undefined, h: 76 }, other), loading ? (React.createElement(Skeleton, { w: "100%", h: "100%" })) : (React.createElement(React.Fragment, null,
        React.createElement(MapButtonImage, { pos: "absolute", h: 90, top: "50%", left: "50%", transform: "translate(-50%, -50%)" }),
        React.createElement(Button, { color: "primary", size: "s", onClick: onClick }, SRP_MAPBUTTON_LABEL)))));
}
